import React from 'react';
import AppSubmenu from './AppSubmenu';

const AppMenu = (props) => {
    const normalizedModel = (props.model || []).map(group => ({
        label: group.label,
        icon: group.icon,
        items: group.items || []
    }));

    return (
        <AppSubmenu
            className="layout-menu layout-main-menu clearfix"
            items={normalizedModel}
            menuMode={props.menuMode}
            menuActive={props.active}
            root
            onMenuitemClick={props.onMenuitemClick}
            onRootMenuitemClick={props.onRootMenuitemClick}
        />
    );
};

export default AppMenu;
